import Home from "@/views/public/Home.vue";
import RouteEnum from "@/router/RouteEnum";

export default [
    {
        path: "/",
        name: RouteEnum.HOMEPAGE,
        component: Home
    },
]
